"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_4 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_5 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_6 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_7 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_8 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_9 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_10 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_11 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_12 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_13 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_14 = require("@biomemakers/bmk_ui_framework");
const TrialsPanel_vue_1 = __importDefault(require("../TrialsPanel.vue"));
const TagSynthetic_vue_1 = __importDefault(require("../CompositionTool/components/TagSynthetic.vue"));
const floating_vue_1 = require("floating-vue");
const lucide_vue_next_1 = require("lucide-vue-next");
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const ModalsSelectsModuleResults_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/ModalsSelectsModuleResults.vue"));
const ModalChangeModule_vue_1 = __importDefault(require("@becrop/components/Modules/Common/Components/ModalChangeModule.vue"));
const ModuleChangePayload_1 = __importDefault(require("@becrop/components/Modules/Common/Models/ModuleChangePayload"));
let TableProjects = class TableProjects extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // MixPanel init
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.selectedCertificateId = 0;
        this.selectedAreaId = 0;
        this.areaName = '';
        this.activeQRModal = false;
        this.activeTrialsPanel = false;
        this.newVisibility = false;
        this.isDeployChangeModule = false;
        this.moduleChangePayload = new ModuleChangePayload_1.default({});
        this.prodID = null;
        this.criteriaArr = [];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    getMyAcreage(extension, extension_unit) {
        const acreage = new Acreage_1.default(Number(extension), extension_unit);
        return acreage.shortLabel;
    }
    get hasAccessToTracking() {
        return (window.localStorage.modulesAvailable.includes('tracking')) ? true : false;
    }
    travelDistroTool(pId, aId) {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('projectActionTriggered', {
            origin: originModule,
            type: 'to_distro',
            projectId: pId,
            farmId: aId
        });
        window.location.href = `/results/distro?projectId=${pId}&areaId=${aId}`;
    }
    getMyAccent(cat) {
        let tempcat = cat.split('+').join('a');
        tempcat = tempcat.toLowerCase();
        return tempcat;
    }
    dismissModalTime() {
        this.isDeployChangeModule = false;
    }
    deployModalChangeModule() {
        this.isDeployChangeModule = true;
    }
    hasContinuation(i) {
        if (i < this.projectLines.length - 1) {
            if (this.projectLines[i].project_id === this.projectLines[i + 1].project_id ||
                (this.projectLines[i].type === this.projectLines[i + 1].type &&
                    this.projectLines[i].area.meta.crop.id ===
                        this.projectLines[i + 1].area.meta.crop.id)) {
                return true;
            }
        }
        return false;
    }
    isContinuing(i) {
        if (i !== 0) {
            if (this.projectLines[i].project_id === this.projectLines[i - 1].project_id ||
                (this.projectLines[i].type === this.projectLines[i - 1].type &&
                    this.projectLines[i].area.meta.crop.id ===
                        this.projectLines[i - 1].area.meta.crop.id)) {
                return true;
            }
        }
        return false;
    }
    deployQRModal() {
        this.activeQRModal = true;
    }
    dismissQRModal() {
        this.activeQRModal = false;
    }
    deployTrialsPanel(projId) {
        this.activeTrialsPanel = true;
        this.prodID = projId;
        this.deployTrialsPanelMixpanel();
        return projId;
    }
    deployTrialsPanelMixpanel() {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('deployTrialsPanel', {
            origin: originModule,
        });
        this.mixpanelHandler.trackEvent('projectActionTriggered', {
            origin: originModule,
            type: 'download_result',
        });
    }
    dismissTrialsPanel() {
        this.activeTrialsPanel = false;
        this.dismissTrialsPanelMixpanel();
    }
    dismissTrialsPanelMixpanel() {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('dismissTrialsPanel', {
            origin: originModule,
        });
    }
    downloadReport(id) {
        window.open('/data/results/certificate/' + id, '_blank');
        this.downloadReportMixpanel(id);
    }
    downloadReportMixpanel(value) {
        const originModule = localStorage.getItem('currentModule');
        const certificateId = value;
        this.mixpanelHandler.trackEvent('downloadReportRate', {
            origin: originModule,
            certificateId: certificateId,
        });
        this.mixpanelHandler.trackEvent('projectActionTriggered', {
            origin: originModule,
            type: 'download_result',
        });
    }
    seeQR(id, name) {
        this.selectedCertificateId = id;
        this.areaName = name;
        this.deployQRModal();
        this.seeQRMixpanel(id, name);
    }
    seeQRMixpanel(id, areaName) {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('seeQR', {
            origin: originModule,
            certificateId: id,
            areaName: areaName,
        });
        this.mixpanelHandler.trackEvent('projectActionTriggered', {
            origin: originModule,
            type: 'see_qr',
        });
    }
    toggleVisibility(id, currentVisibility) {
        this.newVisibility = !currentVisibility;
        this.$emit('toggleVisibility', id, this.newVisibility);
        this.toggleVisibilityMixpanel(id, currentVisibility);
    }
    toggleVisibilityMixpanel(reportId, currentVisibility) {
        const originModule = localStorage.getItem('currentModule');
        let visibility = 'Public';
        if (currentVisibility) {
            visibility = 'Private';
        }
        this.mixpanelHandler.trackEvent('toggleVisibilityRate', {
            origin: originModule,
            reportId: reportId,
            currentVisibility: visibility,
        });
        this.mixpanelHandler.trackEvent('projectActionTriggered', {
            origin: originModule,
            type: 'toggle_visibility',
        });
    }
    onClickOnStatusTag(projLine) {
        if (this.hasAccessToTracking) {
            const builtURL = '/tracking/proposalslist?proposal=' + this.proposalId;
            // Deploy modal change module
            this.moduleChangePayload = new ModuleChangePayload_1.default({
                originModule: 'results',
                destinationModule: 'tracking',
                url: builtURL,
            });
            this.deployModalChangeModule();
        }
    }
    shortMixpanel(value) {
        const originModule = localStorage.getItem('currentModule');
        const criteria = value;
        let direction = this.direction;
        this.criteriaArr.push(criteria);
        if (this.criteriaArr.length >= 2) {
            if (this.criteriaArr[0] !== this.criteriaArr[1]) {
                direction = 0;
            }
            this.criteriaArr.shift();
        }
        if (direction === 0) {
            direction = 1;
        }
        else if (direction === 1) {
            direction = -1;
        }
        else if (direction === -1) {
            direction = 0;
        }
        this.mixpanelHandler.trackEvent('proposalsDetailListSorting', {
            direction: direction,
            criteria: criteria,
            origin: originModule,
        });
    }
    chooseSortable(c) {
        this.$emit('updateSortable', c);
        this.shortMixpanel(c);
    }
    launchResult(pId, aId) {
        window.location.href =
            '/results/map?projectId=' +
                pId +
                '&areaId=' +
                aId +
                '&proposalCode=' +
                this.proposalCode;
        this.launchResultMixpanel(pId, aId);
    }
    launchResultMixpanel(projectId, areaId) {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('launchResult', {
            origin: originModule,
            projectId: projectId,
            areaId: areaId,
        });
        this.mixpanelHandler.trackEvent('projectActionTriggered', {
            origin: originModule,
            type: 'to_map_results',
        });
    }
    downloadFarmPDF(projLine) {
        const url = `/data/results/farm/pdf/${projLine.area.meta.id}`;
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        window.open(url);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TableProjects.prototype, "projectLines", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableProjects.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableProjects.prototype, "theadElements", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableProjects.prototype, "hasRate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProjects.prototype, "textSearch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProjects.prototype, "criteria", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TableProjects.prototype, "direction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TableProjects.prototype, "proposalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], TableProjects.prototype, "proposalCode", void 0);
TableProjects = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TrialsLogo: bmk_ui_framework_1.TrialsLogo,
            RateLogo: bmk_ui_framework_1.RateLogo,
            YieldLogo: bmk_ui_framework_1.YieldLogo,
            FarmLogo: bmk_ui_framework_1.FarmLogo,
            DiseasesLogo: bmk_ui_framework_1.DiseasesLogo,
            ManagementLogo: bmk_ui_framework_1.ManagementLogo,
            TableHeader: bmk_ui_framework_3.TableHeader,
            TableHeaderCell: bmk_ui_framework_4.TableHeaderCell,
            TableBmk: bmk_ui_framework_5.TableBmk,
            TableBody: bmk_ui_framework_6.TableBody,
            TableBodyRow: bmk_ui_framework_7.TableBodyRow,
            TableBodyCell: bmk_ui_framework_8.TableBodyCell,
            Modal: bmk_ui_framework_9.Modal,
            CrossIcon: bmk_ui_framework_10.CrossIcon,
            Button: bmk_ui_framework_13.Button,
            InputField: bmk_ui_framework_14.InputField,
            Toasts: bmk_ui_framework_11.Toasts,
            Tag: bmk_ui_framework_12.Tag,
            TrialsPanel: TrialsPanel_vue_1.default,
            Dropdown: floating_vue_1.Dropdown,
            Mail: lucide_vue_next_1.Mail,
            Lock: lucide_vue_next_1.Lock,
            Eye: lucide_vue_next_1.Eye,
            ArrowUpRight: lucide_vue_next_1.ArrowUpRight,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            QrCode: lucide_vue_next_1.QrCode,
            Key: lucide_vue_next_1.Key,
            ModalsSelectsModuleResults: ModalsSelectsModuleResults_vue_1.default,
            ModalChangeModule: ModalChangeModule_vue_1.default,
            WavesIcon: bmk_ui_framework_2.WavesIcon,
            TagSynthetic: TagSynthetic_vue_1.default,
            Download: lucide_vue_next_1.Download
        },
    })
], TableProjects);
exports.default = TableProjects;
